var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "offline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296,452.26A207.66,207.66,0,0,0,405.2,387H325.87c-2.23,7.64-4.65,15-7.27,21.91C312,426.44,304.36,441,296,452.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,339.47,140.71,261H42.29A207.17,207.17,0,0,0,62.24,339.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.62,238c.73-36.73,4.81-71.88,11.84-103H76.87A206.15,206.15,0,0,0,42.36,238Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.09,161.2,360.29,238h96.36A207.42,207.42,0,0,0,437.09,161.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.05,452.25c-7.36-9.87-14.11-22.23-20.11-36.9L160.7,437.59A207,207,0,0,0,203.05,452.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.05,47.74A207.65,207.65,0,0,0,94.69,112h78.73q3.22-10.92,7-20.91C187,73.56,194.64,59,203.05,47.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343.4,261c-.67,36.7-4.68,71.85-11.64,103h91a206.24,206.24,0,0,0,33.92-103Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.35,85.36,339,62.74a206.46,206.46,0,0,0-43-15C303.42,57.78,310.28,70.38,316.35,85.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29,364h73.92c5.88-24.74,10-53.58,11.6-85.52Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5,457.5c18.63,0,38.45-26.25,52.39-70.5h-90.6l-10.61,10.61C214.32,435.41,232.41,457.5,249.5,457.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5,42.5c-18.49,0-38.15,25.85-52.08,69.5h92.29l8.87-8.87C284.91,64.87,266.7,42.5,249.5,42.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.14,222.57,266.71,135H191C185,160.23,180.69,189.78,179.14,222.57Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M393.32,108.87l-1.12-1.12a201.55,201.55,0,0,0-26.41-22.33L84.92,366.29a202.2,202.2,0,0,0,22.33,26.41l1.3,1.3a203.43,203.43,0,0,0,25.25,21L414.49,134.3A203.35,203.35,0,0,0,393.32,108.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.5dd051d8.svg";
export { ForwardRef as ReactComponent };